export const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_madini-tech/artifacts/ibmk64ve_ChatGPT%20Image%2026%20%D9%8A%D9%88%D9%84%D9%8A%D9%88%202026%D8%8C%2006_47_18%20%D9%85.png";

const U = "https://images.unsplash.com/photo-";
const Q = "?auto=format&fit=crop&w=1100&q=70";
const px = (id, w = 1000) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const IMAGES = {
  heroCity: U + "1611416457332-946853cc75d6" + Q,
  aiNetwork: px(8386440),
  infrastructure: U + "1680992044138-ce4864c2b962" + Q,
  teamMeeting: px(1181745),
  dashboard: U + "1551288049-bebda4e38f71" + Q,
};

// Videos (direct MP4 — Pexels CDN, verified)
export const VIDEOS = {
  hero: "https://videos.pexels.com/video-files/1851190/1851190-hd_1920_1080_25fps.mp4",
  heroPoster: U + "1611416457332-946853cc75d6" + Q,
  intro: "https://videos.pexels.com/video-files/3141210/3141210-hd_1920_1080_25fps.mp4",
  introPoster: U + "1451187580459-43490279c0fa" + Q,
};

// Default per-project intro videos (Pexels CDN, admin-overridable per project via settings).
// These are generic tech placeholders — admin should replace each via the Settings tab with the actual product demo.
const V_TECH = "https://videos.pexels.com/video-files/3141210/3141210-hd_1920_1080_25fps.mp4";
const V_CITY = "https://videos.pexels.com/video-files/1851190/1851190-hd_1920_1080_25fps.mp4";
export const PROJECT_VIDEOS = [V_CITY, V_TECH, V_CITY, V_TECH, V_CITY, V_TECH, V_CITY];

// Service images (order matches content.services.items)
export const SERVICE_IMAGES = [
  U + "1566073771259-6a8506099945" + Q, // hotel
  U + "1551288049-bebda4e38f71" + Q,    // erp dashboard
  U + "1581092160607-ee22621dd758" + Q, // scada industrial
  U + "1557597774-9d273605dfa9" + Q,    // security cctv
  U + "1467232004584-a241de8bcf5d" + Q, // web design
  U + "1512941937669-90a1b58e7e9c" + Q, // mobile
  px(8386440),                          // AI
  U + "1680992044138-ce4864c2b962" + Q, // hosting
];

// Sector images (order matches content.sectors.items)
export const SECTOR_IMAGES = [
  U + "1571896349842-33c89424de2d" + Q, // hotels
  U + "1486406146926-c627a92ad1ab" + Q, // commercial
  U + "1581091226825-a6a2a5aee158" + Q, // factories
  U + "1519494026892-80bbd2d6fd0d" + Q, // hospitals
  U + "1562774053-701939374585" + Q,    // universities
  U + "1580582932707-520aed937b7b" + Q, // schools
  U + "1449157291145-7efd050a4d0e" + Q, // municipalities
  U + "1529107386315-e1a2ed48a620" + Q, // ministries
  U + "1601584115197-04ecc0da31d7" + Q, // transport
  U + "1497435334941-8c899ee9e8e9" + Q, // oil & energy
];

// Project images (order matches content.projects.items)
export const PROJECT_IMAGES = [
  U + "1566073771259-6a8506099945" + Q, // hotel systems
  U + "1551288049-bebda4e38f71" + Q,    // erp
  U + "1581092160607-ee22621dd758" + Q, // scada
  U + "1467232004584-a241de8bcf5d" + Q, // websites
  U + "1512941937669-90a1b58e7e9c" + Q, // mobile apps
  px(8386440),                          // AI
  U + "1557597774-9d273605dfa9" + Q,    // security
];
